
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CompetenciesSection from './components/CompetenciesSection';
import EducationSection from './components/EducationSection';
import CTASection from './components/CTASection';
import CalendarSection from './components/CalendarSection';
import Footer from './components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <AboutSection />
      <CompetenciesSection />
      <EducationSection />
      <CTASection />
      <CalendarSection />
      <Footer />
    </div>
  );
};

export default HomePage;
